var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import { components } from 'react-select';
import { clipboardUtils } from '@indico-data/utils';
import { Button, Icon, LoadingSpinner, Tooltip } from 'Permafrost/index';
import { StyledCopyableSelect, StyledSelectContainer } from './CopyableSelect.styles';
export function CopyableSelect(props) {
    const { className, options, onChange, value, noOptionsMessage = 'No files found', downloadable, isDownloading, onDownload, } = props;
    const [displayCopySuccess, setDisplayCopySuccess] = useState(false);
    const copyHandler = () => {
        clipboardUtils.copy(value.label);
        setDisplayCopySuccess(true);
        setTimeout(() => {
            setDisplayCopySuccess(false);
        }, 2000);
    };
    const ControlComponent = (props) => {
        return (React.createElement(components.Control, Object.assign({}, props),
            React.createElement(React.Fragment, null,
                React.createElement(Tooltip, { id: "tempIDd", for: "selectFile", block: true }, props.getValue()[0].label),
                React.createElement("div", { "data-tip": true, "data-for": "selectFile", className: "combobox__flex-control" }, props.children))));
    };
    const OptionComponent = (_a) => {
        var props = __rest(_a, []);
        const { value, label } = props.data;
        const id = `${value}-shortened-filename`;
        return (React.createElement(components.Option, Object.assign({}, props),
            React.createElement("div", { className: "combobox__flex-option" },
                React.createElement("p", { "data-tip": true, "data-for": id, className: "combobox__ellipsis" }, label),
                React.createElement(Tooltip, { for: id },
                    React.createElement("p", null, label)))));
    };
    // By default react-select searches both the label and value, we only want to search the labels as the value is the fileId
    const customFilter = (option, searchText) => {
        return option.data.label.toLowerCase().includes(searchText.toLowerCase());
    };
    return (React.createElement(StyledSelectContainer, { className: className, "data-cy": props['data-cy'] },
        React.createElement(StyledCopyableSelect, { classNamePrefix: "combobox", options: options, onChange: onChange, value: value, searchable: true, noOptionsMessage: () => noOptionsMessage, filterOption: customFilter, components: { Option: OptionComponent, Control: ControlComponent } }),
        React.createElement(Button, { className: "copy-filepath__button", variant: "link-style", onClick: copyHandler, "data-for": "copy-filename", "data-tip": true }, displayCopySuccess ? (React.createElement(Icon, { name: "check", size: ['18px'], className: "copy-filepath__check" })) : (React.createElement(Icon, { name: "fa-clipboard", ariaLabel: "copy filename", size: ['18px'] }))),
        React.createElement(Tooltip, { className: "copy-success__tooltip", questionMark: false, place: 'bottom', for: "copy-filename" }, displayCopySuccess ? 'copied!' : 'copy filename'),
        downloadable && onDownload ? (React.createElement(React.Fragment, null,
            React.createElement(Button, { className: "download-file__button", variant: "link-style", onClick: () => onDownload({ variables: { id: value.value } }), disabled: isDownloading, "data-for": "download-filename", "data-tip": true }, isDownloading ? (React.createElement(LoadingSpinner, { size: '16px' })) : (React.createElement(Icon, { name: "output", ariaLabel: "download file", size: ['16px'] }))),
            React.createElement(Tooltip, { className: "download-success__tooltip", questionMark: false, place: 'bottom', for: "download-filename" }, "download file"))) : null));
}
//# sourceMappingURL=CopyableSelect.js.map